const getEnv = (key, fallback) => {
  if (
    process.env.NODE_ENV === "production" &&
    window.APP_CONFIG &&
    window.APP_CONFIG[key] &&
    window.APP_CONFIG[key].trim() !== ""
  ) {
    return window.APP_CONFIG[key].trim();
  }
  if (process.env[key] && process.env[key].trim() !== "") {
    return process.env[key].trim();
  }
  return fallback;
};

const CONFIG = {
  authApi: getEnv("REACT_APP_AUTH_API", "http://localhost:9543/api/v1"),
  groceryApi: getEnv("REACT_APP_GROCERY_API", "http://localhost:5003/api/v1"),
  employeeApi: getEnv("REACT_APP_EMPLOYEE_API", "http://localhost:5092/api/v1"),
  zReportApi: getEnv("REACT_APP_ZREPORT_API", "http://localhost:3422/api/v1"),
  branchApi: getEnv("REACT_APP_BRANCH_API", "https://branch.altinisiksystem.com/api/v1"),
};

export default CONFIG;
